<template>
    <div class="mt-3">
        <div v-if="deals.length > 0" class="row">
            <div v-for="deal in deals" class="col-12 position-relative">
                <a :href="getDealURL(deal.dlsSlug)" class="text-dark stretched-link"></a>

                <div class="row">
                    <!-- image -->
                    <div class="col-md-3 text-md-center">
                        <img class="img-fluid" :src="deal.dlsImage" alt="deal-image">
                    </div>
                    <!-- Details -->
                    <div class="col-md-8 mt-3">
                        <div>{{ deal.dlsApplyTo.toUpperCase() }}</div>
                        <div style="font-size: 16pt">{{ deal.dlsName }}</div>
                        <div>{{ business.bizName.toUpperCase() }}</div>
                        <div>{{ business.type.plType.toUpperCase() }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <h4 class="py-3">{{ text }}</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "DealTab",
    props: {
        business: Object,
    },
    data() {
        return {
            deals: [],
            text: "Loading..."
        }
    },
    computed: {},
    mounted() {
        axios.get("/business/" + this.business.bizBusinessID + "/deals")
            .then(response => {
                // console.log(response);
                this.deals = response.data;
            })
            .catch(error => {
                // console.log(error);
            })
            .finally(response => {
                //if there are no deals to load then this message will be displayed to the user
                this.text = "No deals right now check back later";
            })
    },
    methods: {
        getDealURL: function (dlsSlug) {
            let url = "/" + this.business.type.plSlug;

            if (![8, 9].includes(this.business.bizBusinessTypeID))
                //when NOT a brand or mail order
                url += "/" + this.business.province.plInitials.toLowerCase() + "/" + this.business.region.plSlug;

            url += "/" + this.business.bizSlug + "/deals/" + dlsSlug;

            return url;
        }
    }
}
</script>

<style scoped>
.stick {
    position: sticky;
    top: 0;
}

#applyFilter {
    margin-left: 10px;
    margin-right: 10px;
    line-height: 15px;
    border-radius: 40px;
}
</style>
